import axiosInstance from "../api";
import AuthService from "./AuthService";

// add the token in the axios instance header

const setup = () => {
  axiosInstance.interceptors.request.use(
    (config) => {
      if (AuthService.getAuth()) {
        const tokenExpirationDate = AuthService.getExpirationDate();
        let expirationInMilliseconds = new Date(tokenExpirationDate).getTime();

        const currentDate = new Date().getTime();

        if (currentDate < expirationInMilliseconds) {
          const token = AuthService.getBearerToken();
          if (token) {
            config.headers["Authorization"] = token;
          }
          return config;
        }
        AuthService.logout();
        throw new axios.Cancel("Token expired. Please Login.");
      }
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      return Promise.reject(err);
    }
  );
};

export default setup;
